import { TileLayer } from '@deck.gl/geo-layers/typed';
import { BitmapLayer } from '@deck.gl/layers/typed';
import { getTileSublayerBbox } from 'app/helpers';
import { useAppSelector } from 'app/store/store';

export const useLayerSeaMarks = (showSeaMarks: boolean) => {
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isAnalyticsMode = mode === 'analytics';

  const url = `https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png`;
  const seaMarksLayer = new TileLayer({
    data: url,
    id: 'layer-sea-marks',
    minZoom: 9,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const bounds = getTileSublayerBbox(props.tile);

      return new BitmapLayer(props, {
        data: undefined,
        image: props.data,
        bounds,
      });
    },
    visible: showSeaMarks && !isAnalyticsMode,
  });
  return seaMarksLayer;
};
